export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14332.857b7c32.jpg";